/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import moment from "moment";
import { invalid } from "moment";

import * as XLSX from "xlsx";

type LedgerSource = {
  gl_code: string;
  gl_name: string;
  family_code: string;
  family_name: string;
  main_family_code: string;
  main_family_name: string;
  sub_family_code: string;
  sub_family_name: string;
  child_family_code: string;
  child_family_name: string;
};

interface LedgerEntryParams {
  amc_code: string;
  fund_code: string;
  grossDividend: number;
  netDividend: number;
  refundCapital: number;
  taxAmount: number;
  undistributedLedger: LedgerSource;
  payableLedger: LedgerSource;
  saleUnitLedger: LedgerSource;
  whtLedger: LedgerSource;
}

var accountTitle_AccountNumber_Regex = /^[0-9a-zA-Z -]+$/;
function numberWithCommas(amount: any) {
  if (
    amount === "NaN" ||
    isNaN(amount) ||
    amount === "" ||
    amount === undefined ||
    amount === null
  ) {
    return "0";
  } else {
    return amount.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }
}
function toProperCase(str) {
  return str.replace(/(^|\s)\S/g, function (t) {
    return t.toUpperCase();
  });
}

const capitalizeFirstLetters = (str) => {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// fund.stock_market position that still holds shares - a full sale leaves unit 0
// with a residual cost amount behind, which must not be listed as a holding
const hasOpenUnits = (position: any) =>
  parseFloat(position?.unit || 0) !== 0 ||
  parseFloat(position?.total_units || 0) !== 0;

function getLedgerAccounts(data: any) {
  let accountsData = data.map((item: any, index: number) => {
    let gl = item.gl;
    let glData = gl
      ? gl.map((gl: any) => {
          if (gl.active === true) {
            return {
              plsCode: item.code,
              plsName: item.name,
              ...gl,
            };
          } else {
            return {};
          }
        })
      : [{}];
    return glData;
  });
  const results = accountsData.flat().filter((element) => {
    if (Object.keys(element).length !== 0) {
      return true;
    }

    return false;
  });
  // return accountsData.flat();
  return results;
}

// function getLedgersOfTxn(data:any){
//  const ledgers = data.main_family.map((item:any, index:number)=>{
//   let familyData = item.family;
//    const family = familyData.map((familyF:any, ind:number)=>{
//     let subData = familyF.sub_family;
//     const subFamily = subData.map((subfamily:any, i:number)=>{
//       if(subfamily.child_family!=undefined){
//         let child_family= subfamily.child_family;
//         const childFamilyData = child_family.map((itm:any,n:number)=>{
//           let gl= itm.gl;
//           const glData = gl.map((glItem:any, j:number)=>{
//             return{
//               main_family_code:item.code,
//               main_family_name:item.name,
//               family_code:familyF.code,
//               family_name:familyF.name,
//               sub_family_code:subfamily.code,
//               sub_family_name:subfamily.name,
//               child_family_code:itm.code,
//               child_family_name:itm.name,
//               ...glItem,
//             }
//           })
//         })
//       }else{
//         let gl= subfamily.gl;
//         const glData = gl.map((glItem:any, j:number)=>{
//           return{
//             main_family_code:item.code,
//             main_family_name:item.name,
//             family_code:familyF.code,
//             family_name:familyF.name,
//             sub_family_code:subfamily.code,
//             sub_family_name:subfamily.name,
//             child_family_code:'',
//             child_family_name:'',
//             ...glItem,
//           }
//         })
//       }
//     })
//    })
//  })
// }

function getLedgersByTxn(txnCategory, txnType: any) {
  const txn = txnCategory?.filter((item: any) => {
    return item?.api_name === txnType || item?.txn_type === txnType;
  });
  let txnLedgers = txn[0]?.ledgers;
  const legders = txnLedgers?.map((Item: any) => {
    if (Item?.ledger_root?.length > 1) {
      return {
        amount_type: Item?.amount_type,
        desc: "",
        type: "Debit",
        amc_code: "",
        fund_code: "",
        account_number: "",
        account_title: "",
        bank_code: "",
        branch: "",
        balance: "",
        counter_account_number: "",
        counter_account_title: "",
        counter_bank: "",
        counter_branch: "",
        credit_amount: "0",
        debit_amount: "0",
        description: "",
        entered_by: "",
        evidence: "",
        instruction_date: "",
        instrument_by: "",
        instrument_date: "",
        instrument_no: "",
        instrument_type: "",
        realized: "",
        realized_by: "",
        realized_date: "",
      };
    } else {
      const findLedgers = Item?.ledger_root?.map((itm: any) => {
        return {
          ...itm,
          amount_type: Item?.amount_type,
          desc: Item?.desc,
          type: Item?.type,
          amc_code: "",
          fund_code: "",
          account_number: "",
          account_title: "",
          bank_code: "",
          branch: "",
          balance: "",
          counter_account_number: "",
          counter_account_title: "",
          counter_bank: "",
          counter_branch: "",
          credit_amount: "0",
          debit_amount: "0",
          description: "",
          entered_by: "",
          evidence: "",
          instruction_date: "",
          instrument_by: "",
          instrument_date: "",
          instrument_no: "",
          instrument_type: "",
          realized: "",
          realized_by: "",
          realized_date: "",
        };
      });
      return findLedgers;
    }
  });

  return legders?.flat();
}

function getLedgersByTxnAndPaymentype(
  txnCategory,
  txnType: any,
  paymentType: string,
) {
  const txn = txnCategory.filter((item: any) => {
    return (
      (item.api_name === txnType || item.txn_type === txnType) &&
      item.payment_type === paymentType
    );
  });
  let txnLedgers = txn[0].ledgers;
  const legders = txnLedgers.map((Item: any) => {
    const findLedgers = Item.ledger_root.map((itm: any) => {
      return {
        ...itm,
        amount_type: Item.amount_type,
        desc: Item.desc,
        type: Item.type,
        amc_code: "",
        fund_code: "",
        account_number: "",
        account_title: "",
        bank_code: "",
        branch: "",
        balance: "",
        counter_account_number: "",
        counter_account_title: "",
        counter_bank: "",
        counter_branch: "",
        credit_amount: "0",
        debit_amount: "0",
        description: "",
        entered_by: "",
        evidence: "",
        instruction_date: "",
        instrument_by: "",
        instrument_date: "",
        instrument_no: "",
        instrument_type: "",
        realized: "",
        realized_by: "",
        realized_date: "",
      };
    });
    return findLedgers;
  });

  return legders.flat();
}

function getGrossAmountLedgersByTxn(txnCategory, txnType: any) {
  const txn = txnCategory.filter((item: any) => {
    return item.api_name === txnType || item.txn_type === txnType;
  });
  let txnLedgers = txn[0].ledgers;
  const legders = txnLedgers.map((Item: any) => {
    if (Item.ledger_root.length > 1 && Item.amount_type === "Gross Amount") {
      const findLedgers = Item.ledger_root.map((itm: any) => {
        return {
          ...itm,
          amount_type: Item.amount_type,
          desc: Item.desc,
          type: Item.type,
          amc_code: "",
          fund_code: "",
          account_number: "",
          account_title: "",
          bank_code: "",
          branch: "",
          balance: "",
          counter_account_number: "",
          counter_account_title: "",
          counter_bank: "",
          counter_branch: "",
          credit_amount: "0",
          debit_amount: "0",
          description: "",
          entered_by: "",
          evidence: "",
          instruction_date: "",
          instrument_by: "",
          instrument_date: "",
          instrument_no: "",
          instrument_type: "",
          realized: "",
          realized_by: "",
          realized_date: "",
        };
      });
      return findLedgers;
    } else {
      return {};
    }
  });

  const results = legders.flat().filter((element) => {
    if (Object.keys(element).length !== 0) {
      return true;
    }

    return false;
  });

  return results;
}

function getSSTAmountLedgersByTxn(txnCategory, txnType: any) {
  const txn = txnCategory.filter((item: any) => {
    return item.api_name === txnType || item.txn_type === txnType;
  });
  let txnLedgers = txn[0].ledgers;
  const legders = txnLedgers.map((Item: any) => {
    if (Item.ledger_root.length > 1 && Item.amount_type === "SST/PST Amount") {
      const findLedgers = Item.ledger_root.map((itm: any) => {
        return {
          ...itm,
          amount_type: Item.amount_type,
          desc: Item.desc,
          type: Item.type,
          amc_code: "",
          fund_code: "",
          account_number: "",
          account_title: "",
          bank_code: "",
          branch: "",
          balance: "",
          counter_account_number: "",
          counter_account_title: "",
          counter_bank: "",
          counter_branch: "",
          credit_amount: "0",
          debit_amount: "0",
          description: "",
          entered_by: "",
          evidence: "",
          instruction_date: "",
          instrument_by: "",
          instrument_date: "",
          instrument_no: "",
          instrument_type: "",
          realized: "",
          realized_by: "",
          realized_date: "",
        };
      });
      return findLedgers;
    } else {
      return {};
    }
  });

  const results = legders.flat().filter((element) => {
    if (Object.keys(element).length !== 0) {
      return true;
    }

    return false;
  });

  return results;
}

function getAllLedgers(data: any) {
  if (data && data?.main_family) {
    data = data?.main_family;
  }
  let finalLedgers: any = [];
  const ledgers = data?.map((item: any, index: number) => {
    let familyData = item.family;
    const family = familyData.map((familyF: any, ind: number) => {
      let subData = familyF.sub_family;
      const subFamily = subData.map((subfamily: any, i: number) => {
        if (subfamily.child_family !== undefined) {
          let child_family = subfamily.child_family;
          const childFamilyData = child_family.map((itm: any, n: number) => {
            let gl = itm.gl;
            const glData = gl.map((glItem: any, j: number) => {
              let obj = { ...glItem };
              if (obj.active === true) {
                finalLedgers.push({ ...glItem });
              }
            });
          });
        } else {
          let gl = subfamily.gl;
          const glData = gl.map((glItem: any, j: number) => {
            let obj = { ...glItem };
            if (obj.active === true) {
              finalLedgers.push({ ...glItem });
            }
          });
        }
      });
    });
  });
  return finalLedgers;
}

function getCounterAccountLedgers(data: any, txnType: string) {
  const ledgers = [data].map((items: any, index: number) => {
    let gl = items.gl;
    let gls = gl.map((item: any) => {
      return {
        sub_family_code: items.code,
        sub_family_name: items.name,
        ...items,
      };
    });
    return gls;
  });
  return ledgers.flat();
}

function removeEmptyLedgers(ledgers: any) {
  const nonEmptyLedgers = ledgers.filter((Item: any) => {
    delete Item.desc;
    return +Item.debit_amount > 0 || +Item.credit_amount > 0;
  });
  return nonEmptyLedgers;
}

function getReveresedValue(value) {
  if (value === "NaN" || value === undefined) {
    value = "0";
  }

  if (+value < 0) {
    value = value.toString().replace("-", "");
  }
  if (+value > 0) {
    value = "(" + value + ")";
  }
  return numberWithCommas(value);
}

function getLedgerInfoByLedgerCode(chartOfAccounts, ledgerCode) {
  let obj = {};
  const ledgers = chartOfAccounts.map((item: any, index: number) => {
    let familyData = item.family;
    const family = familyData.map((familyF: any, ind: number) => {
      let subData = familyF.sub_family;
      const subFamily = subData.map((subfamily: any, i: number) => {
        if (subfamily.child_family !== undefined) {
          let child_family = subfamily.child_family;
          const childFamilyData = child_family.map((itm: any, n: number) => {
            let gl = itm.gl;
            const glData = gl.map((glItem: any, j: number) => {
              if (glItem.code === ledgerCode) {
                obj = {
                  gl_code: glItem.code,
                  gl_name: glItem.name,
                  amount_type: "",
                  desc: "",
                  type: "",
                  amc_code: "",
                  fund_code: "",
                  account_number: "",
                  account_title: "",
                  bank_code: "",
                  branch: "",
                  balance: "",
                  counter_account_number: "",
                  counter_account_title: "",
                  counter_bank: "",
                  counter_branch: "",
                  credit_amount: "0",
                  debit_amount: "0",
                  description: "",
                  entered_by: "",
                  evidence: "",
                  instruction_date: "",
                  instrument_by: "",
                  instrument_date: "",
                  instrument_no: "",
                  instrument_type: "",
                  realized: "",
                  realized_by: "",
                  realized_date: "",
                  sub_family_code: subfamily.code,
                  sub_family_name: subfamily.name,
                  main_family_code: item.code,
                  main_family_name: item.name,
                  family_code: familyF.code,
                  family_name: familyF.name,
                  child_family_code: itm.code,
                  child_family_name: itm.name,
                };
              }
              //  finalLedgers.push({...glItem});
            });
          });
        } else {
          let gl = subfamily.gl;
          const glData = gl.map((glItem: any, j: number) => {
            if (glItem.code === ledgerCode) {
              obj = {
                gl_code: glItem.code,
                gl_name:
                  glItem.name === undefined
                    ? glItem.account_title
                    : glItem.name,
                amount_type: "",
                desc: "",
                type: "",
                amc_code: "",
                fund_code: "",
                account_number: "",
                account_title: "",
                bank_code: "",
                branch: "",
                balance: "",
                counter_account_number: "",
                counter_account_title: "",
                counter_bank: "",
                counter_branch: "",
                credit_amount: "0",
                debit_amount: "0",
                description: "",
                entered_by: "",
                evidence: "",
                instruction_date: "",
                instrument_by: "",
                instrument_date: "",
                instrument_no: "",
                instrument_type: "",
                realized: "",
                realized_by: "",
                realized_date: "",
                sub_family_code: subfamily.code,
                sub_family_name: subfamily.name,
                main_family_code: item.code,
                main_family_name: item.name,
                family_code: familyF.code,
                family_name: familyF.name,
                child_family_code: 0,
                child_family_name: "",
              };
            }
            //  finalLedgers.push({...glItem});
          });
        }
      });
    });
  });
  return obj;
}

function getNegativeValue(value) {
  if (value === "NaN" || value === undefined) {
    value = "0";
  }
  if (+value < 0) {
    value = "(" + value.replace("-", "") + ")";
  }
  return numberWithCommas(value);
}

function validDate(date) {
  if (date === "invalid date") {
    date = "";
  }
  return date;
}

function isNumber(value) {
  if (
    value === "" ||
    isNaN(value) ||
    value === "NaN" ||
    value === undefined ||
    value === "undefined"
  ) {
    value = "0";
  }
  return value;
}

const SectorCodes = [
  { sector_code: "0801", sector_name: "AUTOMOBILE ASSEMBLER" },
  { sector_code: "0802", sector_name: "AUTOMOBILE PARTS & ACCESSORIES" },
  { sector_code: "0803", sector_name: "CABLE & ELECTRICAL GOODS" },
  { sector_code: "0804", sector_name: "CEMENT" },
  { sector_code: "0805", sector_name: "CHEMICAL" },
  { sector_code: "0806", sector_name: "CLOSE - END MUTUAL FUND" },
  { sector_code: "0807", sector_name: "COMMERCIAL BANKS" },
  { sector_code: "0808", sector_name: "ENGINEERINGR" },
  { sector_code: "0809", sector_name: "FERTILIZER" },
  { sector_code: "0810", sector_name: "FOOD & PERSONAL CARE PRODUCTS" },
  { sector_code: "0811", sector_name: "GLASS & CERAMICS" },
  { sector_code: "0812", sector_name: "INSURANCE" },
  {
    sector_code: "0813",
    sector_name: "INV. BANKS / INV. COS. / SECURITIES COS.",
  },
  { sector_code: "0814", sector_name: "JUTE" },
  { sector_code: "0815", sector_name: "LEASING COMPANIES" },
  { sector_code: "0816", sector_name: "LEATHER & TANNERIES" },
  { sector_code: "0818", sector_name: "MISCELLANEOUS" },
  { sector_code: "0819", sector_name: "MODARABAS" },
  { sector_code: "0820", sector_name: "OIL & GAS EXPLORATION COMPANIES" },
  { sector_code: "0821", sector_name: "OIL & GAS MARKETING COMPANIES" },
  { sector_code: "0822", sector_name: "PAPER & BOARD" },
  { sector_code: "0823", sector_name: "PHARMACEUTICALS" },
  { sector_code: "0824", sector_name: "POWER GENERATION & DISTRIBUTION" },
  { sector_code: "0825", sector_name: "REFINERY" },
  { sector_code: "0826", sector_name: "SUGAR & ALLIED INDUSTRIES" },
  { sector_code: "0827", sector_name: "SYNTHETIC & RAYON" },
  { sector_code: "0828", sector_name: "TECHNOLOGY & COMMUNICATION" },
  { sector_code: "0829", sector_name: "TEXTILE COMPOSITE" },
  { sector_code: "0830", sector_name: "TEXTILE SPINNING" },
  { sector_code: "0831", sector_name: "TEXTILE WEAVING" },
  { sector_code: "0832", sector_name: "TOBACCO" },
  { sector_code: "0833", sector_name: "TRANSPORT" },
  { sector_code: "0834", sector_name: "VANASPATI & ALLIED INDUSTRIES" },
  { sector_code: "0835", sector_name: "WOOLLEN" },
  { sector_code: "0836", sector_name: "REAL ESTATE INVESTMENT TRUST" },
  { sector_code: "0837", sector_name: "EXCHANGE TRADED FUNDS" },
  { sector_code: "0838", sector_name: "PROPERTY" },
  { sector_code: "0", sector_name: "Other" },
];

const CategoryTypesFundDropdown = [
  "Aggressive Income Fund",
  "Asset Allocation Fund",
  "Income Fund",
  "Stock Fund",
  "Debt Fund",
  "Fund of Fund",
  "Livestock",
  "Real Estate Investment Trust (REIT) Scheme",
  "Money Market Fund",
  "Islamic Money Market Fund",
  "Fixed Rate Money Market Fund",
  "Fixed Rate Islamic Money Market Fund",
  "Voluntary Pension Fund",
  "Islamic Pension Fund",
  "Private Equity",
  "Venture Capital",
  "Special Managed Account (SMA)",
  "Shariah Income Fund",
  "Provident Fund",
];

const unitholderCategoryType = ["Unitholder", "Participant", "Employee"];

const fundCategoryTypeArr = ["Employer", "AMC", "Private"];

// const typeRatioSystematic = [
//   {
//     label:"Conservative",
//     ratio: {
//       "Equity":"10-25%",
//       "Debt":"40-60%",
//       "Money Market":"30-50%",
//     }
//   },
//   {
//     label:"Balanced",
//     ratio: {
//       "Equity":"35-50%",
//       "Debt":"20-40%",
//       "Money Market":"20-35%",
//     }
//   },
//   {
//     label:"Aggressive",
//     ratio: {
//       "Equity":"65-80%",
//       "Debt":"10-25%",
//       "Money Market":"10-25%",
//     }
//   },
//   // {
//   //   label:"Customized Allocation Scheme",
//   //   ratio: "100"
//   // },
// ]

const typeRatioSystematic = [
  {
    label: "Conservative",
    ratio: {
      "Stock Fund": "10-25%",
      "Debt Fund": "40-60%",
      "Money Market Fund": "30-50%",
    },
  },
  {
    label: "Balanced",
    ratio: {
      "Stock Fund": "35-50%",
      "Debt Fund": "20-40%",
      "Money Market Fund": "20-35%",
    },
  },
  {
    label: "Aggressive",
    ratio: {
      "Stock Fund": "65-80%",
      "Debt Fund": "10-25%",
      "Money Market Fund": "10-25%",
    },
  },
];

const systematicVPSType = [
  "Conservative",
  "Balanced",
  "Aggressive",
  "Customized Allocation Scheme",
];

const getAllSecurityTypesArr = [
  { label: "Pakistan Investment Bonds", value: "PIB" },
  { label: "Treasury Bill", value: "TBILL" },
  { label: "Sukuk Certificates", value: "SUKUK" },
  { label: "Term Finance Certificates", value: "TFC" },
  { label: "Commercial Papers", value: "CP" },
  { label: "Term Deposit Receipts", value: "TDR" },
  { label: "Certificate Of Investment", value: "CDR" },
  { label: "Letter of Placement", value: "LOP" },
  { label: "Bai Mujjal Placement", value: "Bai Mujjal Placement" },
];

const VPFType = ["Equity", "Debt", "Money Market"];

export const showVPSFundLogic = {
  "Provident Fund": true,
  "Voluntary Pension Fund": true,
  "Debt Fund": true,
  "Stock Fund": true,
  "Money Market Fund": true,
};

const ArrforNumberVal = [
  "Balance",
  "Credit Amount",
  "Debit Amount",
  "Capital Refund Units",
  "Fund Units",
  "NAV",
  "Gross Amount",
  "Sale Load",
  "Redemption Load",
  "CGT",
  "Net Amount",
  "Closing Units",
  "Credit",
  "Debit",
];

// --------- Reports Functions here ----------
function exportToTxt(formattedContent, selectedValues, Data, file_name) {
  formattedContent +=
    selectedValues?.columns
      ?.filter((item) => item !== "Balance")
      ?.map((col) => `"${col}"`)
      .join(",") + "\n";

  Data.forEach((data, index) => {
    const cellContents = Object.keys(data)
      .map((col) => {
        let content = data[col] ? data[col].toString().trim() : "";
        if (ArrforNumberVal?.includes(col)) {
          content = content.replace(/,/g, "");
        }
        return !isNaN(content)
          ? `"\t${
              ArrforNumberVal?.includes(col) && data[col] !== ""
                ? numberWithCommas(content)
                : content
            }",`
          : `"${content}",`;
      })
      .join("");

    formattedContent +=
      index === Data.length - 1 ? cellContents : cellContents + "\n";
  });

  const blob = new Blob([formattedContent], { type: "text/plain" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${file_name}.txt`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // saveAs(blob, 'ledger report.txt');
}

function exportToTxtNCCPL(formattedContent, selectedValues, Data, file_name) {
  // formattedContent +=
  //   selectedValues?.columns?.filter((item) => item !== "Balance")?.join(",") +
  //   "\n";

  Data.forEach((data, index) => {
    const cellContents = Object.keys(data)
      .map((col) => {
        let content = data[col] ? data[col].toString().trim() : "";

        if (ArrforNumberVal?.includes(col)) {
          content = content.replace(/,/g, "");
          if (content !== "" && !isNaN(content)) {
            let formatted = numberWithCommas(content);
            return `"${formatted}"`;
          }
        }
        return content;
      })
      .join(",");

    formattedContent +=
      index === Data.length - 1 ? cellContents : cellContents + "\n";
  });

  const blob = new Blob([formattedContent], { type: "text/plain" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${file_name}.txt`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function s2ab(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
}
function generateExcel(
  file_name,
  title,
  subject = "",
  sheet_name = "",
  author = "",
  headings: any,
  columns: any,
  file_data: any,
  TotalAndClosingBalanceRow,
  ClosingRow,
) {
  const work_book = XLSX.utils.book_new();
  work_book.Props = {
    Title: title,
    Subject: subject,
    Author: author,
    CreatedDate: new Date(),
  };
  work_book.SheetNames.push(sheet_name);

  const sheet_data = XLSX.utils.aoa_to_sheet([
    ...headings,
    columns,
    ...(file_data?.length > 0
      ? file_data
          ?.map((row: any) => {
            return {
              ...row,
              debit: row?.debit !== "" ? row?.debit?.toFixed(2) : "",
              credit: row?.credit !== "" ? row?.credit?.toFixed(2) : "",
            };
          })
          ?.map((row) => Object?.values(row))
      : []),
    TotalAndClosingBalanceRow,
    ClosingRow,
  ]);
  // sheet_data["!cols"] = fitToColumn([columns]);
  work_book.Sheets[sheet_name] = sheet_data;
  const work_book_export = XLSX.write(work_book, {
    bookType: "xlsx",
    type: "binary",
    // raw: false,
    // defval: "",
  });
  // Create a Blob and download the file
  const blob = new Blob([s2ab(work_book_export)], {
    type: "application/octet-stream",
  });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${file_name}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // saveAs(
  //     new Blob([s2ab(work_book_export)], { type: "application/octet-stream" }),
  //     `${file_name}.xlsx`
  // );
}

const calculateLedgerTotals = (calculatedLedgersData: any) => {
  // Check if data exists and has calculatedLedgers array
  if (!calculatedLedgersData?.calculatedLedgers?.length) {
    return {
      totalDebit: 0,
      totalCredit: 0,
    };
  }

  const totals = calculatedLedgersData.calculatedLedgers.reduce(
    (acc, item) => {
      const debitAmount = parseFloat(item.debit_amount || 0);
      const creditAmount = parseFloat(item.credit_amount || 0);

      acc.totalDebit += debitAmount;
      acc.totalCredit += creditAmount;

      return acc;
    },
    { totalDebit: 0, totalCredit: 0 },
  );

  return {
    totalDebit: parseFloat(totals.totalDebit.toFixed(4)),
    totalCredit: parseFloat(totals.totalCredit.toFixed(4)),
  };
};

function handleNegativeValue(valueA, valueB) {
  let properVal = +valueA > 0 && +valueA > +valueB;
  return properVal ? true : false;
}

function shouldHighlight(item, key, value, requiredFieldsMap) {
  const transactionType = item?.TransactionType;
  const requiredFields = requiredFieldsMap[transactionType];
  return requiredFields?.includes(key) && value?.trim() === "";
}

const generateDividendLedgerEntries = ({
  amc_code,
  fund_code,
  grossDividend,
  netDividend,
  refundCapital,
  taxAmount,
  undistributedLedger,
  payableLedger,
  saleUnitLedger,
  whtLedger,
}: LedgerEntryParams) => {
  const period = sessionStorage.getItem("active_period") || "";
  const fixed = (value: number) =>
    parseFloat(value.toString() || "0").toFixed(4);

  const base = (
    type: "debit" | "credit",
    amount: number,
    description: string,
    ledger: LedgerSource,
  ) => ({
    account_number: "",
    account_title: "",
    amc_code,
    balance: "",
    bank_code: "",
    branch: "",
    child_family_code: ledger.child_family_code,
    child_family_name: ledger.child_family_name,
    counter_account_number: "",
    counter_account_title: "",
    counter_bank: "",
    counter_branch: "",
    created_at: "",
    credit_amount: type === "credit" ? fixed(amount) : "0",
    debit_amount: type === "debit" ? fixed(amount) : "0",
    description,
    doc_type: "",
    entered_by: "",
    evidence: "",
    family_code: ledger.family_code,
    family_name: ledger.family_name,
    fund_code,
    gl_code: ledger.gl_code,
    gl_name: ledger.gl_name,
    instruction_date: "",
    instrument_by: "",
    instrument_date: "",
    instrument_no: "",
    instrument_type: "",
    main_family_code: ledger.main_family_code,
    main_family_name: ledger.main_family_name,
    realized: "true",
    realized_by: "",
    realized_date: "",
    sub_family_code: ledger.sub_family_code,
    sub_family_name: ledger.sub_family_name,
    period,
    paid: false,
  });

  const reinvestAmount = netDividend + taxAmount;

  return [
    base("debit", grossDividend, `Gross Dividend`, undistributedLedger),
    base("credit", grossDividend, `Gross Dividend`, payableLedger),
    base("debit", refundCapital, `Dividend ROC`, payableLedger),
    base("debit", reinvestAmount, `Dividend Re-Invest Amount`, payableLedger),
    base("credit", refundCapital, `Dividend ROC`, saleUnitLedger),
    base("credit", netDividend, `Dividend Re-Invest`, saleUnitLedger),
    base("credit", taxAmount, `WHT - Dividend`, whtLedger),
  ];
  // return [
  //   base("debit", grossDividend, "Gross Dividend", undistributedLedger),
  //   base("credit", grossDividend, "Gross Dividend", payableLedger),
  //   base("debit", refundCapital, "Refund of Capital - Dividend", payableLedger),
  //   base("debit", reinvestAmount, "Reinvest Amount - Dividend", payableLedger),
  //   base("credit", refundCapital, "Refund of Capital - Dividend", saleUnitLedger),
  //   base("credit", netDividend, "Reinvest - Dividend", saleUnitLedger),
  //   base("credit", taxAmount, "WHT - Dividend", whtLedger),
  // ];
};
const accountPurposeOptions = [
  "Dividend",
  "Redemption",
  "Loan",
  "Collection",
  "Conservative",
  "Balanced",
  "Aggressive",
];
function sortAMCS(data) {
  let sortedData = data.sort(function (a, b) {
    let x = a.name.toLowerCase();
    let y = b.name.toLowerCase();
    if (x > y) {
      return 1;
    }
    if (x < y) {
      return -1;
    }
    return 0;
  });
  return sortedData;
}

const getSystemFormat = (date) => {
  return moment(date, ["YYYY-MM-DD", "MM/DD/YYYY", "DD/MM/YYYY"]).format(
    "YYYY-MM-DD",
  );
};

const getLedgerInfoByLedgerCodeWorking = (coa, ledgerCode) => {
  let obj = {};
  coa.forEach((item: any) => {
    item.family.forEach((familyF: any) => {
      familyF.sub_family.forEach((subfamily: any) => {
        if (subfamily.child_family !== undefined) {
          subfamily.child_family.forEach((itm: any) => {
            itm.gl.forEach((glItem: any) => {
              if (Number(glItem.code) === Number(ledgerCode)) {
                obj = {
                  gl_code: glItem.code,
                  gl_name: glItem.name,
                  sub_family_code: subfamily.code,
                  sub_family_name: subfamily.name,
                  main_family_code: item.code,
                  main_family_name: item.name,
                  family_code: familyF.code,
                  family_name: familyF.name,
                  child_family_code: itm.code,
                  child_family_name: itm.name,
                };
              }
            });
          });
        } else {
          subfamily.gl.forEach((glItem: any) => {
            if (Number(glItem.code) === Number(ledgerCode)) {
              obj = {
                gl_code: glItem.code,
                gl_name: glItem.name || glItem.account_title,
                sub_family_code: subfamily.code,
                sub_family_name: subfamily.name,
                main_family_code: item.code,
                main_family_name: item.name,
                family_code: familyF.code,
                family_name: familyF.name,
                child_family_code: 0,
                child_family_name: "",
              };
            }
          });
        }
      });
    });
  });
  return obj;
};

const getKarachiDate = () => {
  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Karachi",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  console.log(formatter.format(new Date()).replace(/ /g, "-"));

  return formatter.format(new Date()).replace(/ /g, "-");
};

function isDateValid(date) {
  if (date == invalid || date == "Invalid date") {
    date = "";
  }
  return date;
}

export {
  handleNegativeValue,
  calculateLedgerTotals,
  numberWithCommas,
  toProperCase,
  accountTitle_AccountNumber_Regex,
  getLedgerAccounts,
  getLedgersByTxn,
  getAllLedgers,
  getCounterAccountLedgers,
  getGrossAmountLedgersByTxn,
  getLedgersByTxnAndPaymentype,
  getSSTAmountLedgersByTxn,
  removeEmptyLedgers,
  getReveresedValue,
  getLedgerInfoByLedgerCode,
  getNegativeValue,
  validDate,
  isNumber,
  generateExcel,
  exportToTxt,
  exportToTxtNCCPL,
  SectorCodes,
  CategoryTypesFundDropdown,
  capitalizeFirstLetters,
  hasOpenUnits,
  shouldHighlight,
  generateDividendLedgerEntries,
  VPFType,
  unitholderCategoryType,
  systematicVPSType,
  typeRatioSystematic,
  getAllSecurityTypesArr,
  fundCategoryTypeArr,
  accountPurposeOptions,
  sortAMCS,
  getSystemFormat,
  getLedgerInfoByLedgerCodeWorking,
  getKarachiDate,
  isDateValid,
};
